import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  container: {
    height: '100%',
    display: 'flex',
    padding: 17,
    flexDirection: 'column',
    overflow: 'auto',
  },
  grid: {
    maxWidth: 689,
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingBottom: 48,
  },
  header: {
    marginBottom: 18,
    marginLeft: 25,
    display: 'flex',
    justifyContent: 'space-between',
  },
  infoContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: 34,
  },
  titleContainer: {
    display: 'flex',
    paddingBottom: 26,
    width: '100%',
    position: 'relative',
    justifyContent: 'center',
  },
  title: {
    color: theme.palette.custom.primary1,
    fontWeight: 700,
  },
  // Item styles
  item: {
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    padding: '16px 24px',
    marginBottom: 8,
    width: '100%',
    [theme.breakpoints.up('md')]: {
      padding: '16px 40px',
    },
  },
  itemTitle: {
    color: theme.palette.custom.primary1,
    fontWeight: 700,
    fontFamily: theme.typography.fontFamilyNunito,
  },
  itemValue: {
    color: theme.palette.custom.primary1,
    fontWeight: 400,
    fontFamily: theme.typography.fontFamilyNunito,
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
  valueContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  itemList: {
    width: '100%',
  },
  avatarContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: 20,
  },
}));

export default useStyles;
